/**
 * Cookie Consent helper (LGPD).
 *
 * Stored in localStorage as JSON under key 'cookie_consent':
 *   {
 *     version: '2026-02-10',
 *     timestamp: '<ISO>',
 *     essential: true,        // always true (required for the app to work)
 *     analytics: bool,        // PostHog
 *   }
 *
 * If the saved version is different from CURRENT_VERSION, the banner should
 * be shown again (re-consent required when the policy changes).
 */

const STORAGE_KEY = 'cookie_consent';
export const CURRENT_VERSION = '2026-02-10';

export const ALL_REJECTED = {
  essential: true,
  analytics: false,
};

export const ALL_ACCEPTED = {
  essential: true,
  analytics: true,
};

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== CURRENT_VERSION) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function setConsent(prefs) {
  const payload = {
    version: CURRENT_VERSION,
    timestamp: new Date().toISOString(),
    essential: true,
    analytics: !!prefs.analytics,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {
    // ignore quota errors
  }
  applyConsent(payload);
  window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: payload }));
  return payload;
}

export function clearConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) { /* noop */ }
}

/**
 * Apply the consent decisions to third-party tools (PostHog now, others later).
 * Safe to call multiple times.
 */
export function applyConsent(prefs) {
  if (!prefs) return;
  if (typeof window === 'undefined' || !window.posthog) return;
  try {
    if (prefs.analytics) {
      window.posthog.opt_in_capturing();
    } else {
      window.posthog.opt_out_capturing();
    }
  } catch (_) { /* posthog stub not ready yet */ }
}
